import { RiErrorWarningLine, RiFlag2Line } from "react-icons/ri";
import { getOrderRisk } from "./orderWorkspaceRules";
import styles from "./OrdersWorkspace.module.css";

const RISK_ICONS = {
  danger: RiFlag2Line,
  warning: RiErrorWarningLine,
};

const OrderRiskBadge = ({ order }) => {
  const risk = getOrderRisk(order);
  if (!risk) return null;

  const RiskIcon = RISK_ICONS[risk.tone];

  return (
    <span className={`${styles.semanticBadge} ${styles[`risk-${risk.tone}`]}`}>
      <RiskIcon aria-hidden="true" />
      {risk.label}
    </span>
  );
};

export default OrderRiskBadge;
